// extracted by mini-css-extract-plugin
module.exports = {"loadingImage":"LoadingImage_loadingImage__8YO_R"};